import { useQuery } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { CustomField } from 'types';

const getCustomFields = async (orgId: string, projectId?: string): Promise<CustomField[]> => {
  const params = new URLSearchParams({ orgId });
  if (projectId) {
    params.append('projectId', projectId);
  }
  const response = await customAxios.get<CustomField[]>(`/custom-fields?${params.toString()}`);
  return response.data;
};

export const useGetCustomFields = (orgId: string, projectId?: string) =>
  useQuery<CustomField[]>({
    queryKey: ['custom-fields', orgId, projectId],
    queryFn: () => getCustomFields(orgId, projectId),
    enabled: !!orgId,
  });
